module.exports = __webpack_public_path__ + "img/Support-skill-233.45e53a00.png";